import type { SelectRegistryKey } from "@/config/selectRegistry";

export const SELECT_STALE_TIME_MS = 5 * 60_000;
export const SELECT_GC_TIME_MS = 30 * 60_000;

export const selectKeys = {
  all: ["select"] as const,
  one: (key: SelectRegistryKey) => ["select", key] as const,
};
